import {Moment} from "moment"
import React from "react"
import DatePicker from "react-datepicker"
import moment from "moment"

interface IComponentProps {
    onDateChanged: (onDateChanged: Moment) => void
    currentDate?: Moment
}

interface IComponentFormat {
    currentDate?: Moment
    errors: string[]
}

export default class AvantDatePicker extends React.Component<IComponentProps, IComponentFormat> {
    constructor(props: IComponentProps) {
        super(props)

        this.state = {
            currentDate: props.currentDate === null ? undefined : props.currentDate,
            errors: []
        }
    }

    componentDidUpdate(prevProps: IComponentProps, prevState: IComponentFormat) {
        if (prevProps.currentDate !== this.props.currentDate) {
            this.setState({currentDate: moment(this.props.currentDate)})
        }
    }

    onChange = (date: Date) => {
        this.setState({currentDate: moment(date)})
        this.props.onDateChanged(moment(date))
    }

    render() {
        // get list of item formats from enum by iterating the enums and getting their values
        return <DatePicker selected={this.state.currentDate ? this.state.currentDate.toDate() : undefined} onChange={this.onChange} data-tst-id="keyExpirationDate" />
    }
}
